// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"ff2bd0a7","787":"58c58a36","838":"d5b5385e"}[chunkId] + ".chunk.js";
};